module.exports = __webpack_public_path__ + "static/media/kim48.1daef3ad.png";